import { ApiClient } from 'lib/api-clients';
import { ApiClientResponse } from 'type/api';
import { SiteDutyConfig } from 'page/Settings/page/RosterSettings/pages/Duties/types';

export interface Duty {
  id: string;
  name: string;
  description?: string;
  // Add other fields as needed
}

export const DutiesApi = {
  /**
   * Get all duties
   */
  getDuties: (): Promise<ApiClientResponse<Duty[]>> =>
    ApiClient.get('/api/health-safety/duties'),

  /**
   * Get duty requirements for a specific site
   * @param siteId - The site ID
   * @param dayOfWeek - Optional day of week filter
   */
  getRequirements: (
    siteId: string,
    dayOfWeek?: string
  ): Promise<ApiClientResponse<SiteDutyConfig[]>> =>
    ApiClient.get(`/api/health-safety/site/${siteId}/requirements`,
      dayOfWeek ? { day: dayOfWeek } : {}
    ),

  /**
   * Save duty requirements for a site
   * @param siteId - The site ID
   * @param data - The requirements data to save
   */
  saveRequirements: (
    siteId: string,
    data: any
  ): Promise<ApiClientResponse<SiteDutyConfig[]>> =>
    ApiClient.put(`/api/health-safety/site/${siteId}/requirements`, data),
};